import { ItemServiceFactory as DefaultItemServiceFactory } from 'spark-core-dx/services'
import { ItemManager } from 'spark-core-dx/managers'
import _ from 'lodash';
import { Operations } from '../../services/ItemServices';
import { dispatchAiPanelCommand } from '../../components/AIChat/aiPanelCommand';

const SHOW_MESSAGE_COMMAND = "ShowMessage";

const commandMatches = (name, expected) =>
    String(name ?? "").trim().toLowerCase() === String(expected ?? "").trim().toLowerCase();

const getExecutableOperationUiCommands = (uiCommands) =>
    Object.fromEntries(
        Object.entries(uiCommands ?? {}).filter(([key]) => !commandMatches(key, SHOW_MESSAGE_COMMAND))
    );

export const getImmediateAiPanelUiCommands = (uiCommands) =>
    Object.fromEntries(
        Object.entries(uiCommands ?? {}).filter(([key]) =>
            commandMatches(key, "AIPanel") || commandMatches(key, "AI_PANEL")
        )
    );

const normalizeOperationResult = (result) => {
    if (result == null) {
        return result;
    }

    if (typeof result.first === "function") {
        return result.first();
    }

    if (Array.isArray(result)) {
        return result[0];
    }

    return result;
};

const toMessageText = (value) => {
    if (value == null) {
        return "";
    }
    if (typeof value === "string") {
        return value.trim();
    }
    if (typeof value === "object") {
        return String(
            value.DisplayMessage
            ?? value.displayMessage
            ?? value.Message
            ?? value.message
            ?? value.Info
            ?? value.info
            ?? ""
        ).trim();
    }
    return String(value).trim();
};

const toMessageDetails = (value) => {
    if (value == null) {
        return [];
    }
    const values = Array.isArray(value) ? value : [value];
    return values
        .map((entry) => {
            if (entry == null) {
                return "";
            }
            if (typeof entry === "string") {
                return entry.trim();
            }
            if (typeof entry === "object") {
                try {
                    return JSON.stringify(entry, null, 2).trim();
                } catch {
                    return String(entry).trim();
                }
            }
            return String(entry).trim();
        })
        .filter(Boolean);
};

const getResultMessage = (result, fallback = "Search failed.") => {
    const displayMessage = toMessageText(
        result?.DisplayMessage
        ?? result?.displayMessage
        ?? result?.Message
        ?? result?.message
    );

    if (displayMessage) {
        return displayMessage;
    }

    return toMessageDetails(result?.MessageDetails ?? result?.messageDetails)[0] ?? fallback;
};

const getResultMessageDetails = (result, message) => {
    const details = toMessageDetails(result?.MessageDetails ?? result?.messageDetails);
    return details.length > 0 ? details : [message];
};

export const shouldDeferOperationUiCommands = (result, deferValueUICommands = false) => {
    if (!deferValueUICommands) {
        return false;
    }

    const normalizedResult = normalizeOperationResult(result);
    const uiCommands = normalizedResult?.UICommands ?? normalizedResult?.uiCommands ?? {};
    const uiCommandKeys = Object.keys(uiCommands);
    return uiCommandKeys.length > 0;
};

class ConvokeObjectManager extends ItemManager {
    constructor(id,coreContext, coreState, itemServiceName, queryItemServiceName, operationName, isWarning) {
        const resolvedItemServiceName = (coreContext.itemServiceFactory ?? DefaultItemServiceFactory).ItemServiceEnum[itemServiceName];
        super(resolvedItemServiceName, coreContext, coreState, isWarning);

        var factory = (coreContext.itemServiceFactory ?? DefaultItemServiceFactory);
        this._itemServiceName = `${resolvedItemServiceName}_data`;
        this._operationName = operationName;
        this._className = itemServiceName;
        this._itemService = factory.GetItemService(itemServiceName, coreState, coreContext, isWarning);
        this._queryItemService = factory.GetItemService(queryItemServiceName, coreState, coreContext, isWarning);
        this._ppItemService = factory.GetItemService("ProfilePreference", coreState, coreContext, isWarning);
        this._id = id;
        this._itemServiceFactory = coreContext.itemServiceFactory ?? DefaultItemServiceFactory;
        this.fieldData = {};
        this._coreContext = coreContext;
    }

    async Query({ model, params, queryParams, skip, take, id}) {
            let queryFilter = model;
            take = take ?? 50000
            if (typeof (model) === 'string') {
                queryFilter = this.buildJSONObjFilter({ filter: model, params, skip:(skip ?? 0), take });
            } else {
                queryFilter = { ...queryFilter, Take: queryFilter?.Take ?? take, Skip: queryFilter?.Skip ?? skip ?? 0 }
            }
            const opArgs = {queryParams, operationName:this._operationName,id,item:queryFilter,isItem:true,isWarning:false, itemServiceOverride: this._queryItemService};
            return this.RunOperation(opArgs).then((r) => {
                return r;
            });
        }

    async LoadMetadata(props) {
        if(!props){
            const profile = this._coreContext?.Profile;
            if (!profile?.ClientId || !profile?.AppId) {
                this.MergeState({
                    loadingMetadata: false,
                    isLoadingBtn: false,
                    metadataError: "Profile context is not ready."
                });
                return {
                    Success: false,
                    Message: "Profile context is not ready."
                };
            }

            props = {
                clientId: profile.ClientId,
                forceReload: true,
                appId: profile.AppId
            };
        }

        if(!props.id){
            props.id = this._id;
        }

        if(!props.id){
            this.MergeState({
                loadingMetadata: false,
                isLoadingBtn: false,
                metadataError: "Object id is required to load metadata."
            });
            return {
                Success: false,
                Message: "Object id is required to load metadata."
            };
        }
        
        return await this.GetMetadata(props);
    }


    //convoke manager base class-mere with Source Object Mgr...
    async GetMetadata({id, forceReload}) {
            id = id ?? this._id;
            const className = `${this._className}|${id}`;
            this.MergeState({
                loadingMetadata: true
            })

            if (this.uiMetadata && !forceReload) {
               console.log("uiMetadata",this.uiMetadata);
               this.MergeState({
                    uiMetadata: this.uiMetadata,
                    loadingMetadata: false
                })

                return {
                    Items: this.uiMetadata,
                    Cached: true,
                }
            } else {

                return this._itemService.single(id).then(async (r) => {
                    if ((r?.length !== undefined && r?.first()?.Success) || r?.Success) {
                        let result = r.first();
                        let selectDataPromise = [];
                        for (const metadata of r.first().Items) {
                            metadata.Fields.forEach(x => {
                                if (x.DataJson || x.DataOperationItem || x.DataOperation)
                                    selectDataPromise.push(this.GetSelectData(x))
                            })
                        }
                        await Promise.allSettled(selectDataPromise);
                    
                       const ppResultsList = await this._ppItemService.list(this.buildJSONObjFilter({
                            filter:`x => x.ClassName == className && x.ProfileId == profileId && x.IsActive == true && x.IsDeleted == false`,
                            params:{profileId:this._coreContext?.Profile?._id,className}}));
                            
                            const ppResults = ppResultsList[0];
                            if(ppResults?.Success && ppResults?.Items?.length > 0 && result?.Items?.length > 0){
                                result.Items[0].ProfilePreferences = ppResults.Items.first();
                            }
                            else{
                                result.Items[0].ProfilePreferences = {ClassName:className, ProfileId: this._coreContext?.Profile?._id,Depth:0,UserFieldPreferences:{},SavedFilters:[]};
                            }

                            this.MergeState({
                                uiMetadata: result.Items,
                                loadingMetadata: false
                            })
                            this.MergeGlobalCachedMetadata({
                                cachedUIMetadata: this.cachedUIMetadata ? _.uniqBy([...this.cachedUIMetadata, ...r.first().Items], '_id') : r.first().Items,
                            })
                       

                        return result;
                    }
                    else {
                        this.MergeState({
                            loadingMetadata: false,
                            metadataError: r?.first?.()?.Message ?? r?.Message ?? "Unable to load metadata."
                        })
                        return r?.first();
                    }
                }).catch((error) => {
                    const message = error?.response?.data?.Message
                        ?? error?.response?.data?.message
                        ?? error?.message
                        ?? "Unable to load metadata.";
                    console.error("Metadata load failed:", message, error);
                    this.MergeState({
                        loadingMetadata: false,
                        isLoadingBtn: false,
                        metadataError: message
                    });
                    return {
                        Success: false,
                        Message: message,
                        Error: error
                    };
                });
            }

    }

    getTotalItemCount(){
     let totalItemCount = this.GetState("totalItemCount");
     if(totalItemCount == 0)
        totalItemCount = null;

     return totalItemCount;
   }



    //Model can be string query or the actual JSON object
    //Force updates forces a rerender.
    //Params are the field names in the string query. 
    //Skip 0 based index, defines starting position. 
    //Take Amount of records to return from database.
    async search({id, searchModel, forceUpdate, queryParams, params, skip, take, itemServiceOverride }) {
             
        this.MergeState({
            loadingSearch: true,
            loadingMetadata: !this.uiMetadata,
            isLoadingBtn: true,
        })

        if (forceUpdate) {
           if (!this.uiMetadata || forceUpdate) {
                this.GetMetadata({id, forceReload: true});
            }
            
            return (
                this.Query({ model: searchModel, params, queryParams, skip, take, id, itemServiceOverride }).then((r) => {
                    if (r?.Success) {
                        const filteredData = r.Items?.first()?.Data ?? []
                        this.MergeState({
                            allData: filteredData,
                            loadingSearch: false,
                            totalItemCount: r.TotalItemCount,
                            isLoadingBtn: false,
                            filteredData: filteredData,
                            searchError: null,
                            searchErrorDetails: null,
                            searchResult: r
                        })
                        return {Items: filteredData, TotalItemCount: r.TotalItemCount}
                    }
                    else if (r) {
                        const message = getResultMessage(r);
                        const messageDetails = getResultMessageDetails(r, message);
                        this.MergeState({
                            allData: [],
                            loadingSearch: false,
                            totalItemCount: 0,
                            isLoadingBtn: false,
                            searchError: message,
                            searchErrorDetails: messageDetails,
                            searchResult: r,
                        })
                        return {
                            Items: [],
                            TotalItemCount: 0,
                            Success: false,
                            Message: message,
                            DisplayMessage: message,
                            MessageDetails: messageDetails,
                            DebugErrorMessage: messageDetails.join("\n"),
                            Result: r
                        }
                    }
                    else {
                        console.log("Search query returned undefined/null.");
                    }
                })
            )
        } else {
            this.MergeState({ loadingSearch: false, isLoadingBtn: false })
            return {Items: this.filteredData,TotalItemCount: this.getTotalItemCount()}
        }
    }

    async RunOperation({ operationName, id, item, queryParams, isFile, isItem, isWarning, processorType, itemServiceOverride, deferValueUICommands = false, supressAllErrors = false }) {
        const resultFunction = (r) => {
            const result = normalizeOperationResult(r);
            const shouldDeferUICommands = shouldDeferOperationUiCommands(result, deferValueUICommands);
            if ((r?.length !== undefined && result?.Success) || result?.Success) {
                if (!shouldDeferUICommands && result.UICommands && result.UICommands["UpdateTable"]) {
                    this._updateTableData(result)
                }

                if (!shouldDeferUICommands && result.UICommands && result.UICommands["RefreshTable"]) {
                    this.search({ forceUpdate: true })
                }
            }
            if(result?.UICommands){
                const commandParams = {Items: result.Items, Value: result.Value };
                const aiPanelCommands = getImmediateAiPanelUiCommands(result.UICommands);
                const handledAiPanel = Object.keys(aiPanelCommands).length > 0 &&
                    dispatchAiPanelCommand(aiPanelCommands, commandParams);
                const commandsToExecute = handledAiPanel
                    ? Object.fromEntries(
                        Object.entries(result.UICommands).filter(([key]) =>
                            !commandMatches(key, "AIPanel") && !commandMatches(key, "AI_PANEL")
                        )
                    )
                    : result.UICommands;
                const executableCommands = shouldDeferUICommands
                    ? {}
                    : getExecutableOperationUiCommands(commandsToExecute);
                if (Object.keys(executableCommands).length > 0) {
                    this._coreContext.executeUICommands(executableCommands, commandParams)
                }
            }

            return result;
        }
        
        let opResult;
        if (item) {
            opResult = await (itemServiceOverride ?? this._itemService).postOperation({ operationType: operationName, id, item, queryParams, isFile, isItem, isWarning, processorType, supressAllErrors }).then(resultFunction);
        }
        else {
            opResult = await (itemServiceOverride ?? this._itemService).getOperation({ operationType: operationName, id, queryParams, isFile, isWarning, processorType, supressAllErrors }).then(resultFunction);
        }
        return opResult;
    }

    getTotalItemCount(){
     let totalItemCount = this.GetState("totalItemCount");
     if(totalItemCount == 0)
        totalItemCount = null;

     return totalItemCount;
   }



    async saveItem(item) {
       throw "Save item not supported by convoke objects."
    }

    async deleteItem(item, deletePermanently) {
        throw "Delete not supported in Convoke.";
    }

    async GetFile(id, fileName) {
        throw "Get file not supported in convoke.";
    }

    async GetFileUrl(id) {
        throw "File Urls not supported in convoke.";
    }
}

export default ConvokeObjectManager;
